// @flow strict
import * as React from "react"
import { useParams } from "react-router-dom"
import { createEditor, Descendant, Editor, Node, Transforms } from "slate"
import { withHistory } from "slate-history"
import { Slate, withReact, Editable, ReactEditor } from "slate-react"
import { TextPost } from "../../../ReactContexts/PostContext"
import { backendWriter } from "../../App"
import { initialValue } from "../../Editor/EditorContainer"
import "./ReplyInputField.css"

function ReplyInputField({
  parentThought,
  providedEmpty: empty,
  providedSetEmpty: setEmpty,
  callback,
  providedAutoFocus,
}: {
  parentThought: TextPost
  providedEmpty: boolean
  providedSetEmpty: React.Dispatch<React.SetStateAction<boolean>>
  callback: Function
  providedAutoFocus?: boolean
}) {
  const [value, _setValue] = React.useState(initialValue)
  const [editor, _setEditor] = React.useState(() => withHistory(withReact(createEditor())))
  const { placeId } = useParams()
  const resetEditor = () => {
    Transforms.delete(editor, {
      at: {
        anchor: Editor.start(editor, []),
        focus: Editor.end(editor, []),
      },
    })
  }
  React.useEffect(() => {
    if (ReactEditor.isFocused(editor)) {
      debugger
      console.log("editor", editor)
    }
    // debugger
  }, [editor])
  const onChange = (children: Descendant[]) => {
    if (children.length > 0 && Node.string(children[0]).length > 0) {
      setEmpty(false)
    } else setEmpty(true)
  }
  React.useEffect(() => {
    if (providedAutoFocus) {
      ReactEditor.focus(editor)
      Transforms.select(editor, Editor.end(editor, []))
    }
  }, [])
  const replyBackend = (e: any) => {
    //if editor isn't empty, submit a reply
    //thought id should always be defined
    if (!empty && !e.shiftKey) {
      const string = Node.string(editor)
      callback()
      backendWriter.addReplyThought(string, parentThought, placeId, editor.children)

      e.preventDefault()
      resetEditor()
      setEmpty(true)
    }
  }
  const handleKeyDown: React.KeyboardEventHandler = (e) => {
    switch (e.key.toLocaleLowerCase()) {
      case "enter":
        replyBackend(e)
        break
    }
  }

  return (
    <div
      className="reply-input-field-container"
      style={{ display: "flex", flexDirection: "row", zIndex: "10", position: "relative" }}
      // navigated to thought by accident when clicked to reply, so stopping propagation
      onClick={(e) => e.stopPropagation()}
    >
      <Slate {...{ editor, value, onChange }}>
        {/* <div className="reply-row"> */}
        <Editable
          style={{ width: "100%" }}
          placeholder={"Express a reply..."}
          onKeyDown={handleKeyDown}
          autoFocus={providedAutoFocus}
        />
      </Slate>

      {empty ? (
        <></>
      ) : (
        <button className={"reply-submit-button" + (empty ? " empty" : "")} onClick={replyBackend}>
          {"↑"}
        </button>
      )}
    </div>
  )
}

export default ReplyInputField
